export default __webpack_public_path__ + "static/media/gif tartaglia.06196acd.gif";